import { Button } from "../ui";
import { useNextT } from "../i18n";
import { useViewingAs } from "../bridges/frame";
import { useAccess } from "../access/api";
import { useAllowChanges, useExtendViewing, useViewingAsMode } from "./viewingAsMode";
import s from "./ViewingAsStrip.module.scss";

/**
 * Boards 384-387 (K4.2/K4.3): under the staff strip, the session's mode and clock. It starts look-only, "Allow changes" turns editing on for this
 * session (no new screen, no restart); at five minutes left it says so and offers "Extend 60 minutes". Money, sign-in, closing and deleting stay blocked.
 */
export const ViewingAsMode = () => {
  const { t } = useNextT();
  const v = useViewingAs();
  const { data: access } = useAccess();
  const active = v.active || !!access?.viewingAs;
  const q = useViewingAsMode(active);
  const allow = useAllowChanges();
  const extend = useExtendViewing();
  const m = q.data;
  if (!active || !m?.active) return null;
  const left = m.minutes_left ?? null;
  const warn = left !== null && left <= (m.warn_at_minutes ?? 5);
  return (
    <section className={s.strip} aria-label={t("shell.viewing.mode_label")}>
      <span>
        <strong>{t(m.look_only ? "shell.viewing.look_only" : "shell.viewing.changes_on")}</strong>
        {left !== null && <> · {warn ? t("shell.viewing.ends_soon", { count: left }) : t("shell.viewing.time_left", { count: left })}</>}
      </span>
      {m.look_only && <Button variant="secondary" loading={allow.isPending} onClick={() => allow.mutate()}>{t("shell.viewing.allow")}</Button>}
      {warn && <Button variant="secondary" loading={extend.isPending} onClick={() => extend.mutate()}>{t("shell.viewing.extend", { minutes: m.extend_minutes ?? 60 })}</Button>}
    </section>
  );
};
